const INVOICE_STATUS = {
  PAID: 'PAID',
  CLOSED: 'CLOSED',
  OPEN: 'OPEN',
  DELAYED: 'DELAYED',
};

export { INVOICE_STATUS };
